import React, { useEffect, useState } from 'react';
import CanvasJSReact from '@canvasjs/react-charts';
import { dashboardAPI } from '../services/api.ts';
import { useTheme } from '../contexts/ThemeContext.tsx';
import { UserGroupIcon } from '@heroicons/react/24/outline';

const CanvasJSChart = CanvasJSReact.CanvasJSChart;

const UsersGraph = () => {
  const { theme } = useTheme();
  const [stats, setStats] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        setLoading(true);
        const response = await dashboardAPI.getUsersGraph();
        setStats(response.data);
      } catch (error) {
        console.error('Failed to fetch dashboard stats:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  // Transform object into an array format suitable for CanvasJS
  const chartData = stats
    ? Object.entries(stats).map(([name, value]) => ({
        label: name,
        y: value,
      }))
    : [];

  const isDark = theme === 'dark';

  const options = {
    animationEnabled: true,
    theme: isDark ? 'dark2' : 'light2',
    backgroundColor: 'transparent',
    title: {
      fontSize: 0,
    },
    axisX: {
      labelFontFamily: 'Montserrat, sans-serif',
      labelFontSize: 12,
      labelFontColor: isDark ? '#9ca3af' : '#6b7280',
      lineColor: isDark ? '#4b5563' : '#e5e7eb',
      tickColor: isDark ? '#4b5563' : '#e5e7eb',
    },
    axisY: {
      gridColor: isDark ? '#374151' : '#f3f4f6',
      lineColor: isDark ? '#4b5563' : '#e5e7eb',
      tickColor: isDark ? '#4b5563' : '#e5e7eb',
      labelFontFamily: 'Montserrat, sans-serif',
      labelFontSize: 12,
      labelFontColor: isDark ? '#9ca3af' : '#6b7280',
    },
    toolTip: {
      backgroundColor: isDark ? '#1f2937' : '#ffffff',
      fontColor: isDark ? '#ffffff' : '#1f2937',
      borderThickness: 0,
      cornerRadius: 8,
      fontFamily: 'Montserrat, sans-serif',
    },
    data: [
      {
        type: 'column',
        color: '#4B8845',
        indexLabelFontFamily: 'Montserrat, sans-serif',
        indexLabelFontSize: 12,
        dataPoints: chartData,
      },
    ],
  };

  return (
    <div className="h-full flex flex-col">
      {/* Header with gradient accent */}
      <div className="mb-6">
        <div className="flex items-center gap-3 mb-2">
          <div className="p-2 bg-gradient-to-br from-purple-500 to-purple-600 rounded-lg shadow-md">
            <UserGroupIcon className="h-5 w-5 text-white" />
          </div>
          <h2 className="text-xl font-bold text-gray-900 dark:text-white">
            Users Per Company
          </h2>
        </div>
        <p className="text-sm text-gray-600 dark:text-gray-400 ml-14">
          Distribution of users across companies
        </p>
      </div>

      {/* Chart Container */}
      <div className="flex-1 min-h-[300px]">
        {loading ? (
          <div className="flex items-center justify-center h-full">
            <div className="text-center">
              <div className="inline-block animate-spin rounded-full h-10 w-10 border-4 border-purple-200 dark:border-purple-800 border-t-purple-600 dark:border-t-purple-400 mb-3"></div>
              <p className="text-sm text-gray-500 dark:text-gray-400 font-medium">
                Loading data...
              </p>
            </div>
          </div>
        ) : (
          <CanvasJSChart options={options} />
        )}
      </div>
    </div>
  );
};

export default UsersGraph;
